import script from "./pwaStatusPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwaStatusPopup.vue?vue&type=script&setup=true&lang=ts"

import "./pwaStatusPopup.vue?vue&type=style&index=0&id=048b56ed&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048b56ed"]])

export default __exports__